import { SET_FILE_ID, UPDATE_IMPORT_STATUS } from '../actions/record_table_ui';

const defaultState = {
  currentStep: 'preview',
  importStatus: 0,
  selectedFileId: 0
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case SET_FILE_ID: {
    return {
      ...state,
      selectedFileId: action.id
    };
  }
  case UPDATE_IMPORT_STATUS: {
    return {
      ...state,
      importStatus: action.status
    };
  }
  default:
    return { ...state };
  }
}
